"use client"; // Error boundaries must be Client Components

import { getLanguageCookie } from "@/data/cookieClient";
import { _t } from "@/lib/utils";
import Link from "next/link";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const language = getLanguageCookie();

  return (
    <html>
      <body>
        <div className="text-center">
          <p className="text-base font-semibold text-primary-600">500</p>
          <h1 className="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
            {_t("page_error", language)}
          </h1>

          <p className="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
            {_t("something_wrong_backend", language)}
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              href="/"
              className="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
            >
              {_t("go_back_home", language)}
            </Link>
            <a
              href="mailto:it@alwasail.com"
              className="text-sm font-semibold text-gray-900"
            >
              {_t("contact_support", language)} <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>
        <div className="mt-10 flex items-center justify-center gap-x-6"></div>
      </body>
    </html>
  );
}